import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { PrivyProvider } from '@privy-io/react-auth';
import './index.css';
import App from './App';
import { AuthBridge } from './components/AuthBridge';
import { ConfigError } from './components/ConfigError';
import { PRIVY_APP_ID, PRIVY_CLIENT_ID, privyConfigured } from './lib/privy';
import { useAppStore } from './stores/appStore';

/** Root wrapper so Privy's modal follows the persisted light/dark preference. */
function Root() {
  const theme = useAppStore((s) => s.theme);
  return (
    <PrivyProvider
      appId={PRIVY_APP_ID}
      clientId={PRIVY_CLIENT_ID}
      config={{
        appearance: {
          theme: theme === 'light' ? '#ffffff' : '#111114',
          accentColor: theme === 'light' ? '#c6f000' : '#d4ff1a',
          logo: `${window.location.origin}/icon-192.png`,
        },
        // Email OTP and Google only — no wallet login. Both must also be enabled
        // in the Privy Dashboard (Login methods), or Privy throws at startup.
        loginMethods: ['email', 'google'],
        // A trading journal does not need a wallet, so none is created automatically.
        embeddedWallets: { ethereum: { createOnLogin: 'off' }, solana: { createOnLogin: 'off' } },
      }}
    >
      <AuthBridge />
      <App />
    </PrivyProvider>
  );
}

createRoot(document.getElementById('root')!).render(<StrictMode>{privyConfigured ? <Root /> : <ConfigError />}</StrictMode>);
